import React from 'react'
import Swipe from 'react-easy-swipe'
import RateLookMale from '../templates/RateLookMale'
import RateLookFemale from '../templates/RateLookFemale'
import CardStackHOC from './CardStackHOC'
import SingleOutfitCardHOC from './SingleOutfitCardHOC'
//import RateOutFitCard from '../templates/RateOutFitCard'

class WelcomeHOC extends React.Component {
  constructor(props) {
    super(props)
    this.gender = this.props.match.params.gender
    this.state = {
      swipeStyle: { transform: 'rotateZ(0deg) translate3d(0, 0, 0)'},
      swipeClass: ''
    }
  }

  onSwipeStart = (event) => {
    //console.log('target', event.target)
    this.setState({swipeClass: 'swiping'})
    //console.log('onSwipeStart', event)
    this.setState({swipeStyle: { transform: 'rotateZ(0deg) translate3d(0, 0, 0)'}})
    //this.setState({buttonLeaveClass: { position: 'absolute', transform: 'scaleX(100) translate3d(0, 0, 0)', opacity: 1 }})
  }

  onSwipeMove = (position, event) => {
    this.setState({ x: position.x })

    if(position.x < 0){
      let x = -position.x
      this.setState({swipeStyle: { transform: 'rotateZ(-'+(x/620)*20+'deg) translate3d(-'+(x/620)*200+'%, 0, 0)'}})
    }
  }

  onSwipeEnd = (event) => {
    if(this.state.x < -180){
      //this.setState({swipeClass: 'swiped'})
      //console.log('this', this)
      if(this.gender === 'm'){
        this.props.history.push(`/ratethelook/m/1`)
      }else{
        this.props.history.push(`/ratethelook/f/1`)
      }

      this.setState({swipeStyle: { transition: 'transform 400ms', transform: 'rotateZ(-20deg) translate3d(-200%, 0, 0)'}})
      //this.setState({buttonLeaveClass: { position: 'absolute', transform: 'scaleX(100) translate3d(0, 0, 0)', opacity: 1 }})
    }else{
      this.setState({swipeClass: ''})
      this.setState({swipeStyle: { transition: 'transform 400ms', transform: 'rotateZ(0deg) translate3d(0, 0, 0)'}})
      //this.setState({buttonLeaveClass: { position: 'absolute', transform: 'scaleX(100) translate3d(0, 0, 0)', opacity: 1 }})
    }

  }

  onNextPage = (nextPage) => {
    this.setState({swipeStyle: { transition: 'transform 400ms, opacity 100ms 200ms', opacity: '0', transform: 'rotateZ(-10deg) translate3d(-100%, 0, 0)'}})
    setTimeout(()=>{ 
      this.props.history.push(nextPage)
      }, 400);

  }



  render() {

    
    if(this.props.data.loading){
      return null
    }

    const card = this.props.data.allOutfits[0]
    //console.log('card', card)

    if(this.gender === 'm'){
      return (
        <CardStackHOC arrowLink={`/ratethelook/m/1`} onNextPage={()=>this.onNextPage(`/ratethelook/m/1`)} >
          <SingleOutfitCardHOC card={card} />
          <Swipe className={`currentCard ${this.state.swipeClass}`} style={this.state.swipeStyle} allowMouseEvents={false} onSwipeMove={this.onSwipeMove} onSwipeStart={this.onSwipeStart} onSwipeEnd={this.onSwipeEnd} >
            <RateLookMale noShadow={true} />
          </Swipe>
        </CardStackHOC>
      )
    }else{
      return (
        <CardStackHOC arrowLink={`/ratethelook/f/1`} onNextPage={()=>this.onNextPage(`/ratethelook/f/1`)}>
          <SingleOutfitCardHOC card={card} />
          <Swipe className={`currentCard ${this.state.swipeClass}`} style={this.state.swipeStyle} allowMouseEvents={false} onSwipeMove={this.onSwipeMove} onSwipeStart={this.onSwipeStart} onSwipeEnd={this.onSwipeEnd} >
            <RateLookFemale noShadow={true} />
          </Swipe>
        </CardStackHOC>
      )
    }
  }
}

export default WelcomeHOC



// WEBPACK FOOTER //
// ./src/components/WelcomeHOC.js